import React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { ViewMode } from '../../../../pages/rounds'
import { Help } from '../../../common/Help'

type Props = {
  view: ViewMode
  setView: React.Dispatch<React.SetStateAction<ViewMode>>
}

export const ViewModeSelector: React.FC<Props> = (props) => {
  const handleViewChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.setView(e.target.value as ViewMode)
  }
  return (
    <div
      css={css`
        display: inline-block;
        margin-left: 30px;
        label {
          margin-right: 30px;
          display: inline-flex;
          input {
            margin-right: 7px;
          }
          :hover {
            cursor: pointer;
          }
        }
        input[type='radio'] {
          appearance: none;
          outline: none;
          height: 16px;
          width: 16px;
          vertical-align: -0.8rem;
          color: #fff;
          cursor: pointer;
        }
        input[type='radio'] {
          border-radius: 50%;
          border: 2px solid ${colors.cyan50};
        }
        input[type='radio']:checked:before {
          transform: scale(1);
        }
        input[type='radio']:before {
          content: '';
          display: block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin: 2px;
          transform: scale(0);
        }
        input[type='radio']:checked:before {
          background: ${colors.cyan50};
        }
      `}
    >
      <label>
        <input
          type="radio"
          name="view"
          value="funding_round"
          checked={props.view === 'funding_round'}
          onChange={handleViewChange}
        />
        調達ラウンド別
      </label>
      <label>
        <input
          type="radio"
          name="view"
          value="series"
          checked={props.view === 'series'}
          onChange={handleViewChange}
        />
        シリーズ別
        <Help
          css={css`
            margin: 1px 0 2px 3px;
          `}
        >
          {`調達ラウンドをシリーズ毎に統合したビュー。\nシリーズが特定されていない調達ラウンドは\n表示されません。`}
        </Help>
      </label>
    </div>
  )
}
